<template>
  <div class="special-terms">
    <p class="special-terms__title">특약사항</p>
    <div class="special-terms__content">
      <p v-for="(item, index) in items" :key="'term_' + index">{{ index + 1 }}. {{ item }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        `사업자(신청인)(본인)가 폐업하는 경우`,
        `서비스 이용을 위해 경남은행과의 펌이체계약은 “출금이체지정서비스”로 계약되며, 채권자의 동의 없이 3회 이상 출금이 발생하는 경우`,
        `매출대금에 대한 압류등의 사유가 발생 하는 경우`,
        `본 약정 체결 이후 연체, 체불 정보 등 신청인(본인)의 신용평가에 악영향을 주는 신용정보가 확인되는 경우`,
        `이용자(본인)가 서비스 제공자의 동의 없이 제신고 계좌를 변경하는 경우`,
        `서비스 제공자와 협의 없이 사업장 매출이 5영업일 이상 발생하지 발생하지 않을 때. 단, 사업장의 특수한 경우로 매출이 발생되는 주기가 5일 이상인 경우는 예외로 한다.`,
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.special-terms {
  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 12px;
  }

  &__content {
    p {
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 0;

      &:not(:last-child) {
        margin-bottom: 18px;
      }
    }
  }
}
</style>
